import React, { useState, useEffect } from 'react';
import eventEmitter from '../../../utils/EventEmitter';
import './Loader.css';

const Loader = () => {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // Listen to loader start and stop events
        const handleLoaderStart = () => setIsLoading(true);
        const handleLoaderStop = () => setIsLoading(false);

        eventEmitter.on('loader:start', handleLoaderStart);
        eventEmitter.on('loader:stop', handleLoaderStop);

        // Cleanup listeners on component unmount
        return () => {
            eventEmitter.off('loader:start', handleLoaderStart);
            eventEmitter.off('loader:stop', handleLoaderStop);
        };
    }, []);

    return (
        <>
            {/* Loader Circle and Blur Effect */}
            {isLoading && (
                <div className="loader-overlay">
                    <div className="loader-circle"></div>
                </div>
            )}
        </>
    );
};

export default Loader;
